import React, { useEffect } from 'react';

import { getPrivacyPolicyLink, MarketingSettings, resolveMarketingWording } from './marketing';
import styles from './marketing-preference.module.scss';

export interface IMarketingPreferenceProps {
    settings: MarketingSettings | null;
    checked: boolean;
    onChange: (checked: boolean) => void;
}

const CHECKBOX_ID = 'marketing-preference-checkbox';

export const MarketingPreference: React.FC<IMarketingPreferenceProps> = ({
    settings,
    checked,
    onChange,
}) => {
    const wording = resolveMarketingWording(settings);
    const privacyPolicyLink = getPrivacyPolicyLink(settings?.privacyPolicyUrl);

    useEffect(() => {
        if (wording && !privacyPolicyLink && process.env.NODE_ENV === 'development') {
            console.warn('Marketing:PrivacyPolicyUrl is not set to an http(s) link, so the privacy policy is shown without a link.');
        }
    }, [wording, privacyPolicyLink]);

    if (!wording) {
        return null;
    }

    return (
        <div className={styles['panel']} data-testid="marketing-preference">
            {wording.intro ? <p className={styles['intro']}>{wording.intro}</p> : null}
            <div className={styles['checkbox-row']}>
                <input
                    id={CHECKBOX_ID}
                    type="checkbox"
                    className={styles['checkbox-input']}
                    checked={checked}
                    onChange={(e) => onChange(e.target.checked)}
                />
                <label htmlFor={CHECKBOX_ID} className={styles['checkbox-label']}>
                    <span className={styles['checkbox-box']} aria-hidden="true" />
                    <span className={styles['checkbox-text']}>{wording.checkboxLabel}</span>
                </label>
            </div>
            <p className={styles['footnote']}>
                {wording.footnote ? `${wording.footnote} ` : ''}
                See our{' '}
                {privacyPolicyLink ? (
                    <a href={privacyPolicyLink} target="_blank" rel="noopener noreferrer">
                        Privacy Policy
                    </a>
                ) : (
                    'Privacy Policy'
                )}
                .
            </p>
        </div>
    );
};

export default MarketingPreference;
